import { render, staticRenderFns } from "./block-socials.vue?vue&type=template&id=508d1591&scoped=true&"
import script from "./block-socials.vue?vue&type=script&lang=js&"
export * from "./block-socials.vue?vue&type=script&lang=js&"
import style0 from "./block-socials.vue?vue&type=style&index=0&id=508d1591&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508d1591",
  null
  
)

export default component.exports